import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter } from "@fortawesome/free-brands-svg-icons"

const Sider = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "favicon.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <section id="sider">
      <Img
        fluid={data.image.childImageSharp.fluid}
        alt="イメージキャラクターです"
        style={{ height: `100%` }}
      ></Img>
      <h2 className="myself">管理人 : tecchan</h2>
      <div className="sns-wrapper">
        <a href="https://twitter.com/tecchanKameWalk/">
          <FontAwesomeIcon
            icon={faTwitter}
            size="2x"
            style={{ color: "#1da1f2" }}
          />
        </a>
        {/* <a href="https://github.com/K-tecchan/">
          <FontAwesomeIcon
            icon={faGithub}
            size="2x"
            style={{color: "black"}}
          />
        </a> */}
      </div>
      <section className="intro">
        <p>
          プログラミング初心者なのでいろいろ勉強してます。なんでもできるようになる予定。目標は年収5億円。好きなものは公園と図書館とラーメン。頭よくなりたいです。
        </p>
        <p>
          詳しくは
          <Link to={"/about/"} className="">
            About
          </Link>
          へ
        </p>
      </section>
    </section>
  )
}
export default Sider
